import axios from 'axios';

export const _axios = axios.create({
  baseURL:
    // 'http://localhost:8082/api/v1'
    'https://zunu.herokuapp.com/api/v1'
})
